/** Dispatched after meeting create/save so onboarding lightboxes can refetch immediately (e.g. agenda builder). */
export const ONBOARDING_VIDEOS_CHECK_EVENT = 'rithmo:onboarding-videos-check'

export function requestOnboardingVideosCheck() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(ONBOARDING_VIDEOS_CHECK_EVENT))
  }
}
